import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from "vue";
import Divider from 'primevue/divider';

export default /*@__PURE__*/_defineComponent({
  __name: 'commonPassword',
  props: {
    modelValue: { type: String, required: true, default: "" },
    name: { type: String, required: true },
    propname: { type: String, required: false },
    placeholder: { type: String, default: "" },
    v$: Object,
    feedback: { type: Boolean, default: false },
    toggleMask: { type: Boolean, default: false },
    Isdisabled: { type: Boolean, default: false }
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;
let Props = __props;
const updateValue = (value: any) => {
    emit("update:modelValue", value);
};

const __returned__ = { emit, get Props() { return Props }, set Props(v) { Props = v }, updateValue }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})